import React from "react";
import { Col, Tooltip, OverlayTrigger, Button } from "react-bootstrap";
import Questions from "../questions";
import { deepEqual } from "../../utils/object";
import { sectionCaptionDisplayed } from "../../utils/sections";

class SectionItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data ?? {}
        }
        this.ref = React.createRef();
    }

    componentDidUpdate = (oldProps) => {
        // Use deep equality here because parent might recreate object references
        if (deepEqual(oldProps.data, this.props.data)) return;

        this.setState({
            data: this.props.data ?? {}
        });
    }

    getData = () => {
        if (this.ref.current) {
            return this.ref.current.getData();
        }
        return this.props.data ?? this.state.data ?? {};
    }

    onChange = (e) => {
        if (this.props.onChange) {
            this.props.onChange();
        }
    }


    get defaultPlacement() {
        return "bottom";
    }

    get overlay() {
        return (
            <OverlayTrigger 
                delay={{ show: 10, hide: 0 }} 
                overlay={<Tooltip>{this.props.tooltip}</Tooltip>} 
                placement={this.props.overlayPlacement || this.defaultPlacement}
            >
                {this.link}
            </OverlayTrigger>
        );
    }

    get link() {
        return (
            <Button 
                variant="link"
                onClick={this.onClick} 
                style={{ color: "Black" }} 
                className={this.props?.active ? "text-decoration-none fw-bolder" : ""}
            >
                {this.props?.caption}
            </Button>
        );
    }
  
    render() {
        if (!this.props.active) return null;

        return (
            <>
                {sectionCaptionDisplayed(this.props) && this.props.caption && (
                    <Col xs="12" className="fs-2">
                        {this.props.caption}
                    </Col>
                )}
                {this.props.description && (
                    <Col xs="12" className="mb-3">
                        {this.props.description}
                    </Col>
                )}
                <Col xs="12">
                    <Questions 
                        ref={this.ref}
                        items={this.props.Questions} 
                        data={this.state.data} 
                        onChange={this.onChange} 
                        allowDynamicDisplay={this.props.allowDynamicDisplay}
                        collectionSections={this.props.collectionSections}
                        richTextLabels={this.props.richTextLabels}
                        sectionKey={this.props.element}
                        validationErrors={this.props.validationErrors}
                    />
                </Col>
            </>
        );
    }
}

export default SectionItem;
